var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessManagment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business_Managment",
    "data-name": "Business Managment",
    transform: "translate(21464 -2138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21464 2138)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_48",
    "data-name": "Union 48",
    d: "M14,50a2,2,0,0,1-2-2V34.509l14,2.239V41a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V36.7l14-2.4V48a2,2,0,0,1-2,2ZM9.241,44.014H2a2,2,0,0,1-2-2v-40a2,2,0,0,1,2-2L25.151,0,33,8.367V13.64H22.5a3.743,3.743,0,0,0-1.719,1.189,4.8,4.8,0,0,0-.74,1.991v2.856H13.66a6.951,6.951,0,0,0-3.365,1.94A6.687,6.687,0,0,0,9.242,25.3V44.013h0ZM4,12.5A1.5,1.5,0,0,0,5.5,14h15a1.5,1.5,0,0,0,0-3H5.5A1.5,1.5,0,0,0,4,12.5Zm0-4A1.5,1.5,0,0,0,5.5,10h15a1.5,1.5,0,0,0,0-3H5.5A1.5,1.5,0,0,0,4,8.5ZM29,40a1,1,0,0,1-1-1V37.067l2.5.4L33,37.04V39a1,1,0,0,1-1,1ZM12,32.168V24a2,2,0,0,1,2-2h8V19a3,3,0,0,1,3-3H36a3,3,0,0,1,3,3v3H37V19.5A1.5,1.5,0,0,0,35.5,18h-10A1.5,1.5,0,0,0,24,19.5V22H47a2,2,0,0,1,2,2v8.038L30.5,35.114Z",
    transform: "translate(-21443 2156)",
    opacity: 0.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessManagment);
export default __webpack_public_path__ + "static/media/Business Managment.81f9f9ce.svg";
export { ForwardRef as ReactComponent };